import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-reviews',
  templateUrl: './profile-tab-reviews.component.html',
  styleUrls: ['./profile-tab-reviews.component.scss']
})
export class ProfileTabReviewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
